exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".terms-title[data-v-3423e622]{font-size:2rem;border-bottom:.6rem solid #18a18e}dt[data-v-3423e622]{padding-top:1.8rem;padding-bottom:.5rem}li[data-v-3423e622]{padding-top:.5rem}", ""]);

// exports
